import axios from 'axios'
import { serialize } from '@/utils/util'
const qs = require('qs')
// 创建axios实例
const service = axios.create({
    baseURL: 'https://dev-learning.zqycloud.com', // 测试api 的 base_url
    // baseURL: 'https://learning.zqycloud.com', // 正式api 的 base_url
    // timeout: 5000, // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
    (config) => {
        if (config.method === 'get' || config.method === 'delete') {
            config.paramsSerializer = function (params) {
                return qs.stringify(params, { arrayFormat: 'repeat' })
            }
        }
        // headers中配置serialize为true开启序列化
        if (config.method === 'post' && config.headers.serialize) {
            config.data = serialize(config.data)
            delete config.data.serialize
        }

        if(config.method === 'post'){
            // if()
            // console.log("config.data = " + JSON.stringify(config.data))
            if(config.data.hasOwnProperty('Authorization')){
                config.headers["Authorization"] = config.data.Authorization
            }
        }
        if(config.method === 'get'){
            if(config.params.hasOwnProperty('Authorization')){
                config.headers["Authorization"] = config.params.Authorization
            }
        }
        config.headers["Version"] = 'v1';
        config.headers["Source"] = 'H5';
        let timeup = (Date.parse(new Date()) / 1000).toString();
        // let uniqueKey = Math.floor(Math.random() * 90 + 10) + timeup.substring(5, 10) + timeup.substring(0, 5) + Math.floor(Math.random() * 90 + 10);
        // config.headers['unique-key'] = uniqueKey;
        config.url = config.url.replace('/api', '')
        return config
    },
    (error) => {
        // Do something with request error
        Promise.reject(error)
    }
)
// response 拦截器
service.interceptors.response.use(
    (response) => {
        if (response.status !== 200) {
            return Promise.resolve(false)
        } else {
            return response.data
        }
    },
    (error) => {
        return Promise.reject(error)
    }
)
// 超时重新请求
service.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config
    config['retry'] = 4
    config['retryDelay'] = 1000
    if (!config || !config.retry) return Promise.reject(err)
    config.__retryCount = config.__retryCount || 0
    if (config.__retryCount >= config.retry) {
        return Promise.reject(err)
    }
    config.__retryCount += 1
    var backoff = new Promise(function (resolve) {
        setTimeout(function () {
            resolve()
        }, config.retryDelay || 1)
    })
    return backoff.then(function () {
        return service(config)
    })
})
export default service